<i class="material-icons basket-icon rounded-circle me-2"> {{iconName}} </i>
